<div class="app-alert display-none" [ngClass]="'display-flex'">
</div>